import {engineContext} from './context.js';

(function(g){'use strict';
const VERSION='0.1.0-alpha';
const cp=x=>x==null?x:JSON.parse(JSON.stringify(x));

const STATES=Object.freeze(['VERIFIED','UNVERIFIED','MISSING','STALE','ERROR']);

function normalizeEnvelope(input={}){
 const state=STATES.includes(input.state)?input.state:'UNVERIFIED';
 return Object.freeze({
  provider:input.provider||null,
  dataset:input.dataset||null,
  symbol:input.symbol||null,
  asOf:input.asOf||null,
  receivedAt:input.receivedAt||null,
  state,
  provenance:cp(input.provenance||{}),
  payload:input.payload===undefined?null:cp(input.payload),
  error:input.error||null
 });
}

function validateEnvelope(e={}){
 const issues=[];
 if(!e.provider) issues.push('PROVIDER_REQUIRED');
 if(!e.dataset) issues.push('DATASET_REQUIRED');
 if(!STATES.includes(e.state)) issues.push('INVALID_STATE');
 if(e.state==='VERIFIED'&&!e.asOf) issues.push('VERIFIED_REQUIRES_ASOF');
 if(e.state==='VERIFIED'&&(!e.provenance||Object.keys(e.provenance).length===0)) issues.push('VERIFIED_REQUIRES_PROVENANCE');
 if(e.state==='ERROR'&&!e.error) issues.push('ERROR_REQUIRES_REASON');
 return Object.freeze({valid:issues.length===0,issues:Object.freeze(issues)});
}

function gate(input={}){
 const e=normalizeEnvelope(input);
 const v=validateEnvelope(e);
 if(!v.valid) return Object.freeze({status:'BLOCK',envelope:e,issues:v.issues,usable:false});
 if(e.state==='ERROR') return Object.freeze({status:'REVIEW',envelope:e,issues:Object.freeze(['PROVIDER_ERROR']),usable:false});
 if(e.state==='MISSING') return Object.freeze({status:'REVIEW',envelope:e,issues:Object.freeze(['DATA_MISSING']),usable:false});
 if(e.state==='STALE') return Object.freeze({status:'REVIEW',envelope:e,issues:Object.freeze(['DATA_STALE']),usable:true});
 if(e.state==='UNVERIFIED') return Object.freeze({status:'REVIEW',envelope:e,issues:Object.freeze(['DATA_UNVERIFIED']),usable:true});
 return Object.freeze({status:'READY',envelope:e,issues:Object.freeze([]),usable:true});
}

function combine(inputs=[]){
 const results=(Array.isArray(inputs)?inputs:[]).map(gate);
 const block=results.some(x=>x.status==='BLOCK');
 const review=results.some(x=>x.status==='REVIEW');
 return Object.freeze({
  version:VERSION,
  status:block?'BLOCK':review?'REVIEW':'READY',
  readyCount:results.filter(x=>x.status==='READY').length,
  reviewCount:results.filter(x=>x.status==='REVIEW').length,
  blockCount:results.filter(x=>x.status==='BLOCK').length,
  results:Object.freeze(results)
 });
}

function selfTest(){
 const t=[],ok=(n,p)=>t.push({name:n,pass:!!p});
 const verified={provider:'SEC',dataset:'fundamentals',symbol:'AAA',state:'VERIFIED',asOf:'2026-08-30',provenance:{url:'source'},payload:{x:1}};
 const n=normalizeEnvelope(verified);
 ok('verified state preserved',n.state==='VERIFIED');
 ok('payload preserved',n.payload.x===1);
 ok('verified envelope validates',validateEnvelope(n).valid===true);
 ok('verified data ready',gate(verified).status==='READY');

 const uv=gate({provider:'P',dataset:'D',state:'UNVERIFIED'});
 ok('unverified data reviews',uv.status==='REVIEW'&&uv.usable===true);

 const miss=gate({provider:'P',dataset:'D',state:'MISSING'});
 ok('missing data reviews unusable',miss.status==='REVIEW'&&miss.usable===false);

 const stale=gate({provider:'P',dataset:'D',state:'STALE'});
 ok('stale data reviews but remains visible',stale.status==='REVIEW'&&stale.usable===true);

 const err=gate({provider:'P',dataset:'D',state:'ERROR',error:'TIMEOUT'});
 ok('provider error reviews',err.status==='REVIEW'&&err.usable===false);

 const badVerified=gate({provider:'P',dataset:'D',state:'VERIFIED'});
 ok('verified without provenance/asOf blocks',badVerified.status==='BLOCK');
 ok('verified missing asOf identified',badVerified.issues.includes('VERIFIED_REQUIRES_ASOF'));
 ok('verified missing provenance identified',badVerified.issues.includes('VERIFIED_REQUIRES_PROVENANCE'));

 const bad=gate({dataset:'D',state:'VERIFIED',asOf:'x',provenance:{a:1}});
 ok('missing provider blocks',bad.status==='BLOCK');

 const c1=combine([verified,verified]);
 ok('all verified combines ready',c1.status==='READY'&&c1.readyCount===2);

 const c2=combine([verified,{provider:'P',dataset:'D',state:'UNVERIFIED'}]);
 ok('unverified member makes combined review',c2.status==='REVIEW');

 const c3=combine([verified,{dataset:'D',state:'VERIFIED',asOf:'x',provenance:{a:1}}]);
 ok('invalid member makes combined block',c3.status==='BLOCK');

 const unknown=normalizeEnvelope({provider:'P',dataset:'D',state:'MAGIC'});
 ok('unknown state becomes unverified',unknown.state==='UNVERIFIED');

 const api={VERSION,normalizeEnvelope,validateEnvelope,gate,combine};
 ok('no trade signal',!('tradeSignal' in api));
 ok('no capital permission',!('capitalPermission' in api));
 ok('no universal score',!('score' in api));

 return Object.freeze({passed:t.filter(x=>x.pass).length,total:t.length,tests:Object.freeze(t)});
}

g.ZooInvestRuntimeDataContractGateway=Object.freeze({VERSION,STATES,normalizeEnvelope,validateEnvelope,gate,combine,selfTest});
})(engineContext);